module.exports = __webpack_public_path__ + "img/monoxid-sensor-sm.a8c933b7.svg";